<div class="picker-list" *ngIf="modifierGroup">
  <div class="picker-list__head">
    <h4 class="picker-list__title">{{ modifierGroup.name }}</h4>
    <div class="picker-list__total small" *ngIf="modifierGroup.restrictions" [ngClass]="{'is-error': formControl.hasError('minCount')}">
      <ng-container *ngIf="!!minCount && minCount === maxCount">
        <span i18n="@@Select">Select</span> {{ maxCount }}
      </ng-container>

      <ng-container *ngIf="minCount === 0 && maxCount !== 0 && maxCount !== 1/0">
        <span i18n="@@SelectTo">Select to</span> {{ maxCount }}
      </ng-container>

      <ng-container *ngIf="minCount > 0 && minCount !== maxCount">
        <span i18n="@@SelectFrom">Select from</span> {{ minCount }}
        <ng-container *ngIf="maxCount !== 1/0">
          <span i18n="@@To">to</span> {{ maxCount }}
        </ng-container>
      </ng-container>

      <ng-container *ngIf="modifierGroup.childModifiersHaveMinMaxRestrictions && maxCount === 0 && minCount === 0">
        <span i18n="@@Select">Select</span>
      </ng-container>
    </div>
  </div>

  <app-single-modifiers
    *ngIf="!isGroupModifier"
    [formControl]="formControl"
    [modifierGroup]="modifierGroup"
    [items]="modifierGroup.items"
    [isCheckMinMaxRestrictions]="modifierGroup.childModifiersHaveMinMaxRestrictions"
    [maxCount]="maxCount || 10000"
    [minCount]="minCount"

    (changeValue)="onChangeModifiers()"
  ></app-single-modifiers>

  <app-group-modifiers
    *ngIf="isGroupModifier"
    [modifierGroup]="modifierGroup"
    [formControl]="formControl"
    [items]="modifierGroup.items"
    [isCheckMinMaxRestrictions]="modifierGroup.childModifiersHaveMinMaxRestrictions"
    [minCount]="minCount"

    (changeValue)="onChangeModifiers()"
  ></app-group-modifiers>
</div>


